export default __webpack_public_path__ + "static/char-thumb-21-1c015fb215db9321d77a370d17a93113.png";